import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import gDataTable from "@/components/g-data-table/g-data-table";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import FiltroPedidosCanceladosLiquidados from "@/shared/view-models/Filtros/FiltroPedidosCanceladosLiquidados";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
import { defineComponent } from "vue";
import EVENTS from "@/shared/events/events"
import AccountLoged from "@/shared/mixins/AccountLoged";

const name = 'CanceladosLiquidados'

export default defineComponent({
  name,

  components: {
    'g-button': gButton,
    'g-card': gCard,
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    Dashboard,
    PedidoEmAndamentoPDF
   },

  props: { },
  watch: {
    formSearch() {
      if (this.formSearch.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  mounted () {
    this.UnidadeArray = this.$store.state.EmpresaArray;
    this.RepresentantesArray = this.$store.state.RepresentanteArray;
    this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    this.StatusArray = PedidoController.GetStatusPedidoEnum().StatusArray;
    this.TipoPedidoArray = PedidoController.GetInformacaoTipoPedidoEnum().TipoPedidoArray;
    this.formSearch.TipoData = 'liquidacao';
    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.PedidosCanceladosLiquidadosArray = null;
    });
   },

  updated () { },

  data () {
    return {
        pt1: true,
        ClienteAgrupadorAtiva: true,
        CheckComponentesExpandidos: false,
        OrcamentoProdutoArray: [],
        CheckClienteAgrupador: false,
        dataClientes: [],
        UnidadeArray: [],
        ClienteArray: [],
        RepresentanteArray: [],
        StatusArray: [],
        ProdutoArray: null,
        linhaSelecionada: {},
        popup: false,
        RepresentantesArray: [],
        PedidosCanceladosLiquidadosArray: [],
        componenteLCPedidoArray: [],
        formSearch: new FiltroPedidosCanceladosLiquidados(),
        pedidoId: null,

        DataPedidoParcelaArray: [
          { value: "liquidacao", campo: "Da Liquidação" },
          { value: "cancelamento", campo: "Do Cancelamento" },
          ],

        Colunas : [
          //Campo dos dados , nome que aparece na página
          {field: 'pedidoParcela', header: 'Pedido / Parcela', width: '180px', ordena: true},
          {field: 'nomeProduto', header: 'Produto', width: '300px', ordena: true},
          {field: 'quantidadeSolicitada', header: 'Qtd. Solicitada', width: '180px', ordena: true ,alinha: 'flex-end',type: 'number'},
          {field: 'quantidadeProduzida', header: 'Qtd. Produzida', width: '180px', ordena: true,alinha: 'flex-end',type: 'number'},
          {field: 'quantidadeExpandida', header: 'Qtd. Expedida', width: '180px', ordena: true,alinha: 'flex-end',type: 'number'},
          {field: 'dataEntregaFormatada', header: 'Dt. Entrega', width: '150px', ordena: true, ordenacao: 'dataEntregaFormatada',alinha: 'center'},
          {field: 'dataCarregamentoFormatada', header: 'Dt. Carregamento', width: '180px', ordena: true, ordenacao: 'dataCarregamentoFormatada',alinha: 'center'},
          {field: 'saldo', header: 'Saldo', width: '100px', ordena: true,alinha: 'flex-end',type: 'number'},
        ],

        ColunasSubGridComponente: [
          { field: "componenteTipoTexto", header: "Componentes" },
          { field: "descricaoFaseProduto", header: "Fase de Produção" },
        ],

        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS}, //permite buscar por colunas específicas
          'codPedido': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeSolicitada': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeProduzida': {value: null, matchMode: this.filtros.CONTAINS},
          'dataEntregaFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'dataCarregamentoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'saldo': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
        },
        TipoPedidoArray: [],
        PedidoId: null,
        renderiza: false,
        executarvisualizacao: 0
     }
    },

    mixins:[AccountLoged],

    methods: {
      gerarPdf() {
        setTimeout(() => {
          this.executarvisualizacao++
        }, "500");
      },

      abrirPDF(data) {
        this.renderiza = true
        this.PedidoId = data.pedidoId
      },

      ativaClienteAgrupador() {
        this.ClienteAgrupadorAtiva = false;
      },
      buscarProdutoNovo(pesquisa) {
        window.clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          ProdutoController.GetProdutoNovoByPesquisa(pesquisa, this.formSearch.UnidadeId).requisicao
          .then((res) => {
            this.OrcamentoProdutoArray = res.data.data
          })
          .catch(() => {
          })
        }, 1000);
      },
      Buscar(){
      this.getLogCancelado()
      this.pt1 = false
      this.GetPedidosCanceladosOuLiquidadosByFiltro()
    },

    notasFiscaisRota(data) {
      this.$router.push(`/notas-fiscais/${data.codigoPedido}`)
    },

    atualizaEmpresaRepresentante() {
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    limparFiltro(){
      this.formSearch = new FiltroPedidosCanceladosLiquidados();
      this.ClientesArray = []
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId

    },

    getEmpresas() {
      this.EmpresaArray = this.$store.state.EmpresaArray;
    },

    FiltroGetClientes (valor) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      ClienteController.getClienteDropDownsByNome(valor, this.formSearch.UnidadeId, this.formSearch.RepresentanteId).requisicao
        .then((Response) => {
          this.dataClientes = Response.data.data;
        })
        .catch(() => {
        })
      }, 1100);
    },

    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoByPesquisaEmpresa(pesquisa, this.formSearch.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },

    getCodigo(produtoId){
      ProdutoController.GetCodigoByProdutoId(produtoId).requisicao
        .then((res) => {
          this.formSearch.CodigoProduto = res.data.message
        })
        .catch(() => {
        })
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },

    getLogCancelado(){
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Pedido/getLogCancelado/`,
      }).then(() => {

      })
    },

    GetPedidosCanceladosOuLiquidadosByFiltro(){
      this.$isLoading(true)

      this.formSearch.RepresentanteId = this.$store.state.representanteSelecionadoId
      PedidoController.GetPedidosCanceladosOuLiquidadosByFiltro(this.formSearch).requisicao
      .then(res => {
        this.PedidosCanceladosLiquidadosArray = res.data.data || []
      })
      .finally(() => this.$isLoading(false))
    },
    
    detalhesPedido(data){
      const rotaNovaAbaURL = this.$router.resolve({
        path: `pedido-cancelado-liquidado-fluxo/${data.pedidoId}/detalhes-pedido-cancelado-liquidado`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },

   },

  computed: { },

});